import { useState } from "react";
import { genreOptions, regionOptions, sortOptions, typeOptions, yearOptions } from "@/mocks/taxonomy";

export interface FilterState {
  type: string;
  genre: string;
  region: string;
  year: string;
  sort: string;
}

interface FilterBarProps {
  filters: FilterState;
  onChange: (key: keyof FilterState, value: string) => void;
  showType?: boolean;
  showSort?: boolean;
  showGenre?: boolean;
}

function ChipGroup({
  label,
  options,
  value,
  onSelect,
}: {
  label: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-start">
      <span className="w-16 shrink-0 pt-1.5 text-sm text-foreground-500">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = value === option;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onSelect(option)}
              className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-200 bg-background-100 text-foreground-700 hover:border-primary-500/60 hover:text-primary-400"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterBar({ filters, onChange, showType = true, showSort = true, showGenre = true }: FilterBarProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-background-200 bg-background-100">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between px-4 py-3 text-sm font-medium text-foreground-800 md:hidden"
      >
        <span className="flex items-center gap-2">
          <i className="ri-filter-3-line text-lg text-primary-400"></i>
          筛选与排序
        </span>
        <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? "rotate-180" : ""}`}></i>
      </button>

      <div className={`${open ? "block" : "hidden"} space-y-4 px-4 pb-4 pt-1 md:block md:space-y-4 md:p-5`}>
        {showType && (
          <ChipGroup label="类型" options={typeOptions} value={filters.type} onSelect={(v) => onChange("type", v)} />
        )}
        {showGenre && (
          <ChipGroup label="标签" options={genreOptions} value={filters.genre} onSelect={(v) => onChange("genre", v)} />
        )}
        <ChipGroup label="地区" options={regionOptions} value={filters.region} onSelect={(v) => onChange("region", v)} />
        <ChipGroup label="年份" options={yearOptions} value={filters.year} onSelect={(v) => onChange("year", v)} />
        {showSort && (
          <ChipGroup label="排序" options={sortOptions} value={filters.sort} onSelect={(v) => onChange("sort", v)} />
        )}
      </div>
    </div>
  );
}